import React, {Component} from 'react'

class CheckBoxInput extends Component {

    async componentDidMount(){
        for(let i = 0; i < this.props.value.length; i++){
            for(let j = 0; j < this.props.data.length; j++){
                if(this.props.value[i] === this.props.data[j]._id){
                    this.props.data[j].initialChecked = true
                }
            }
        }
        this.setState({justSet: true})
    }

    async onChange(e, data){
        if(e.target.checked){
            this.props.value.push(data._id)
        }else{
            this.props.value.splice(this.props.value.indexOf(data._id), 1)
        }
        this.props.onChange({preventDefault: e.preventDefault, target:{value: this.props.value}}, this.props.stateProp)
    }

    lookIfChecked(id){
        for(let i = 0; i < this.props.value.length; i++){
            if(id === this.props.value[i]){
                return true
            }
        }
        return false
    }

    render(){
        return (
            <React.Fragment>
                <label className="checkBox-label"><strong>{this.props.baslik}</strong></label><hr style={{margin: 0}}></hr>
                {this.props.data.map(data => {
                    return (
                        <label className="col-lg-3 col-sm-12" style={data.initialChecked ? {backgroundColor: "#2C3E50", borderRadius: "5px", verticalAlign: "top"} : { verticalAlign: "top" }}>
                            <input className="input-checkbox" checked={this.lookIfChecked(data._id)} type="checkbox" onChange={(e) => this.onChange(e, data)} />
                            <label style={data.initialChecked ? { color: "white", display: "inline" } : { display: "inline" }} className="data-label">{data.labelStrong}</label>
                        </label>
                    )
                })}
            </React.Fragment>
        )
    }  
}
export default CheckBoxInput